import { ViewStream } from "spyne";
//import iframeResize from "@iframe-resizer/parent";

export class PageDocsItemBlockExternalIframe extends ViewStream {
  constructor(props = {}) {
    props.class = "loading";
    /*    iframeResize({
      height: "125vh",
    });*/
    props.channels = ["CHANNEL_UI"];
    props.template = `<h3 class="loading-txt"></h3><iframe width="100%" offset="1500px" height="120vh" src="${props.data.src}" />`;

    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_UI_LOAD*_EVENT", "onLoadingEvent"]];
  }

  onLoadingEvent(e) {
    //console.log("LOAADING ",e);

    const iframe = this.props.el$("iframe").el;
    const getIframeHeight = () => {
      try {
        // Adjust the height of the iframe to match its content
        var iframeDocument = iframe.contentDocument;
        var height = iframeDocument.documentElement.scrollHeight;
        iframe.style.height = height * 1.2 + "px";
      } catch (e) {
        console.error("Error adjusting iframe height:", e);
      }
    };
    window.setTimeout(getIframeHeight, 100);

    this.props.el$.removeClass("loading");
    this.props.el$(".loading-txt").el.remove();
  }

  broadcastEvents() {
    // return nexted array(s)
    return [["iframe", "load"]];
  }

  onRendered() {
    /*    iframeResize({
      license: "GPLv3",
    });*/
    // this.addChannel("CHANNEL_UI");
  }
}
